module.exports = __webpack_public_path__ + "static/media/15.fba5dc67.jpg";